export default {
    topics: [
        {
            title: ' CreateCusResource ',
            href: 'sm-cusResource-CreateCusResource.html',
            attributes: { 'data-id': 'sm-cusResource-CreateCusResource' },
            menu: { hasChildren: false },
            tocID: 'sm-cusResource-CreateCusResource-d66e2287',
            topics: [],
        },
        {
            title: ' CreateFDASchema ',
            href: 'sm-cusResource-CreateFDASchema.html',
            attributes: { 'data-id': 'sm-cusResource-CreateFDASchema' },
            menu: { hasChildren: false },
            tocID: 'sm-cusResource-CreateFDASchema-d66e2295',
            topics: [],
        },
        {
            title: ' GenerateCusResources ',
            href: 'sm-cusResource-GenerateCusResources.html',
            attributes: { 'data-id': 'sm-cusResource-GenerateCusResources' },
            menu: { hasChildren: false },
            tocID: 'sm-cusResource-GenerateCusResources-d66e2303',
            topics: [],
        },
    ],
};

